var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimcard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "rgba(36,93,173,1)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/simcard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/simcard_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simcard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.54 6.79781L16.47 3.72781C15.53 2.78781 14.26 2.25781 12.93 2.25781H8C5 2.25781 3 4.25781 3 7.25781V17.2578C3 20.2578 5 22.2578 8 22.2578H16C19 22.2578 21 20.2578 21 17.2578V10.3278C21 8.99781 20.47 7.72781 19.54 6.79781Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 22.0182V17.0719C17 15.4219 15.65 14.0719 14 14.0719H10C8.35 14.0719 7 15.4219 7 17.0719V22.0182M7 2.41699L7 5.26251M10 2.41699V5.26251M12.7878 2.41699V5.26251",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimcard2);
export default __webpack_public_path__ + "static/media/simcard2.6bea3676645ff3914d3136c38b56daa9.svg";
export { ForwardRef as ReactComponent };